/*=========================================================================================
  File Name: module-invoice-check-history-actions.js
  Description: InvoiceCheckHistory Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import InvoiceCheckHistoryAPI from '@/api/InvoiceCheckHistoryAPI.js';
import commonFunc from '@/common/commonFunction';
export default {
	loadHistorys: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: InvoiceCheckHistoryAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload}`
			},
			true
		);
		if (res && res.Success) {
			context.commit('updateHistorys', res.Data);
		}
		return null;
	}
};
